import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const booking = {
  namespaced: true,
  state: {
    booking: '',
    bookingForm: '',
    isReturnBooking: false,
    reloadBooking: false,
    bookingChangelog: '',
    bookingRepeatServiceId: ''
  },
  getters,
  mutations,
  actions
}
